import { Leaf, ShieldCheck, Truck, Zap } from "lucide-react";

const ITEMS = [
  "SAMSUNG LM301H DIODES",
  "MEANWELL DRIVERS",
  "FREE AU EXPRESS SHIPPING",
  "2-YEAR LOCAL WARRANTY",
  "2.8+ µmol/J EFFICACY",
  "DESIGNED IN AUSTRALIA",
  "SILENT PASSIVE COOLING",
  "FULL SPECTRUM + UV/IR",
];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span className="px-8 font-mono2 text-xs uppercase tracking-[0.35em] text-[#4ADE80]/80">{t}</span>
          <Zap className="h-3 w-3 shrink-0 text-[#39FF14]/60" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee-mask overflow-hidden border-y border-[#39FF14]/10 bg-[#071009] py-4" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}

export function TrustRow() {
  const items = [
    { icon: Truck, label: "Free AU express shipping" },
    { icon: ShieldCheck, label: "2-year local warranty" },
    { icon: Leaf, label: "Home growers & commercial ready" },
  ];
  return (
    <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
      {items.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#39FF14]/25 bg-[#0A150F]">
            <Icon className="h-4 w-4 text-[#39FF14]" />
          </span>
          <span className="text-sm text-[#C9DCD0]">{label}</span>
        </div>
      ))}
    </div>
  );
}
